var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLightTheme)?_c('span',{on:{"click":_vm.toggleTheme}},[_vm._v("☀️")]):_c('span',{on:{"click":_vm.toggleTheme}},[_vm._v("🌙")])])}
var staticRenderFns = []

export { render, staticRenderFns }